

const SchemaOrg = ({ tutorAggregate, metadata, paginationData }) => {
  if (
    !hasPopulatedTutorAggregate(tutorAggregate) ||
    !hasPopulatedMetadata(metadata) ||
    !hasPopulatedPaginationData(paginationData)
  ) {
    return null;
  }

  type Product = {
    "@context": string;
    "@type": string | string[];
    name: string;
    description: string;
    brand: {
      "@type": string;
      name: string;
    }
    aggregateRating: {
      "@type": string;
      ratingValue: number;
      reviewCount: number;
    },
    offers: {
      "@type": string;
      offerCount: number;
      highPrice: number;
      lowPrice: number;
      priceCurrency: string;
      seller: {
        "@type": string;
        name: string;
      }
    },
    priceRange: string;
  }
  interface JSONProduct {
    item: Product;
  }
  
  
  const structuredJSON: JSONProduct = {
    item: {
      "@context": "http://schema.org/",
      "@type": ["Product", "Tuition"],
      name: metadata.headerTitle,
      description: metadata.metaDescription,
      brand: {
        "@type": "Brand",
        name: "MyTutor",
      },
      aggregateRating: {
        "@type": "AggregateRating",
        ratingValue: tutorAggregate.averageLessonRating,
        reviewCount: tutorAggregate.totalReviewCount,
      },
      offers: {
        "@type": "AggregateOffer",
        priceCurrency: "GBP",
        highPrice: tutorAggregate.highestPrice,
        lowPrice: tutorAggregate.lowestPrice,
        offerCount: paginationData.totalSize,
        seller: {
          "@type": "Organization",
          name: "MyTutor",
        },
      },
      priceRange:
          "Prices from £" +
          tutorAggregate.lowestPrice +
          " to £" +
          tutorAggregate.highestPrice,
    },
  };
  
  return <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(structuredJSON.item) }} />;
};

function hasPopulatedTutorAggregate(tutorAggregate) {
  return (
    tutorAggregate &&
    tutorAggregate.totalReviewCount !== null &&
    tutorAggregate.averageLessonRating !== null &&
    tutorAggregate.highestPrice !== null &&
    tutorAggregate.lowestPrice !== null
  );
}

function hasPopulatedMetadata(metadata) {
  return metadata?.schemaOrg;
}

function hasPopulatedPaginationData(paginationData) {
  return paginationData?.totalSize;
}

export default SchemaOrg;
